import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledSwitch } from './styles/StyledSwitch';


class Switch extends Component {
  render() {
    const { isChecked, onChangeHandle, id } = this.props;
    return (
      <StyledSwitch>
        <div className="rsbc-switch-button rsbc-mode-select rsbc-switch-button-flat-round">
          <input
            id={id} 
            type="checkbox"
            checked={isChecked}
            value="1"
            onChange={onChangeHandle}
          />
          <label htmlFor={id}></label>
        </div>
      </StyledSwitch>
    );
  }
}


Switch.propTypes = {
  onChangeHandle: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};


export default Switch;


// WEBPACK FOOTER //
// ./src/common/Switch/Switch.js